import { Fragment } from 'react';
import type { SearchMatch } from '@kiipu/app-protocol';

const fieldNames: Record<SearchMatch['field'], string> = {
  title: '标题',
  note: '备注',
  body: '正文',
  author: '作者',
  source: '来源',
  tag: '标签',
};

/** Ranges describe plain text, never server-generated HTML. */
export function SearchMatchPreview({ match }: { match: SearchMatch }) {
  const ranges = match.ranges
    .filter(
      ({ start, end }) =>
        Number.isInteger(start) &&
        Number.isInteger(end) &&
        start >= 0 &&
        end > start &&
        end <= match.snippet.length,
    )
    .sort((a, b) => a.start - b.start);
  const parts = [];
  let cursor = 0;
  for (const range of ranges) {
    if (range.start < cursor) continue;
    parts.push(
      <Fragment key={range.start}>
        {match.snippet.slice(cursor, range.start)}
        <mark>{match.snippet.slice(range.start, range.end)}</mark>
      </Fragment>,
    );
    cursor = range.end;
  }
  parts.push(<Fragment key="tail">{match.snippet.slice(cursor)}</Fragment>);
  return (
    <span className="search-match" data-match-field={match.field}>
      <span className="search-match-field">
        {!match.snippet && match.field === 'title'
          ? '标题近似匹配'
          : `${fieldNames[match.field]} · `}
      </span>
      {parts}
    </span>
  );
}
